(() => {
  'use strict';
  if (customElements.get('londa-product-bundle')) return;
  class LondaProductBundle extends HTMLElement {
    static order(rows) {
      const chosen = rows.filter(r => r.main || r.selected);
      if (!chosen.length || chosen.some(r => !r.available || !/^\d+$/.test(String(r.id)) || !Number.isSafeInteger(r.price) || r.price < 0)) throw new Error('unavailable');
      const ids = new Set();
      return chosen.reduce((out,r) => {
        if (ids.has(String(r.id))) return out;
        ids.add(String(r.id)); out.items.push({id:String(r.id),quantity:1});
        out.total += r.price; out.compare += Math.max(r.price,r.compare || 0); return out;
      },{items:[],total:0,compare:0});
    }
    connectedCallback() {
      customElements.whenDefined('londa-product').then(() => {
        if (!this.isConnected || this.ready) return;
        this.product = this.closest('londa-product');
        if (!this.product?.ready) return;
        this.ready = true;
        this.labels = JSON.parse(this.querySelector('[data-bundle-labels]').textContent);
        this.form = this.querySelector('[data-bundle-form]');
        this.button = this.querySelector('[data-bundle-add]');
        this.cards = [...this.querySelectorAll('[data-bundle-item]')];
        this.controller = new AbortController();
        const opts = {signal:this.controller.signal};
        this.form.addEventListener('submit',e => this.submit(e),opts);
        this.addEventListener('change',e => {
          if (e.target.matches('[data-bundle-variant]') && e.target.closest('[data-bundle-main]')) this.product.selectVariant(e.target.value,{moveImage:false});
          this.update();
        },opts);
        this.product.addEventListener('londa:variant-change',() => this.syncMain(),opts);
        this.formatter = new Intl.NumberFormat(this.dataset.locale || 'ja',{style:'currency',currency:this.dataset.currency || 'JPY'});
        this.syncMain(); this.hidden = false;
      });
    }
    rows() {
      return this.cards.map(card => {
        const select = card.querySelector('[data-bundle-variant]'), option = select.selectedOptions[0];
        return {card,select,option,id:option?.value,price:Number(option?.dataset.price),compare:Number(option?.dataset.compare),available:!!option && !option.disabled,main:card.hasAttribute('data-bundle-main'),selected:!!card.querySelector('[data-bundle-check]')?.checked};
      });
    }
    syncMain() {
      const select = this.querySelector('[data-bundle-main] [data-bundle-variant]');
      if (select && this.product.selected) select.value = String(this.product.selected.id);
      this.update();
    }
    update() {
      for (const row of this.rows()) {
        const {card,option} = row;
        card.querySelector('[data-bundle-item-price]').textContent = option?.dataset.priceText || '';
        const compare = card.querySelector('[data-bundle-item-compare]');
        compare.hidden = !(row.compare > row.price);
        compare.textContent = option?.dataset.compareText || '';
        const image = card.querySelector('img');
        if (image && option?.dataset.image) image.src = option.dataset.image;
        const check = card.querySelector('[data-bundle-check]');
        if (check) {check.disabled = this.busy || !row.available;if (!row.available) check.checked = false;}
        row.select.disabled = this.busy || ![...row.select.options].some(o=>!o.disabled);
      }
      try {
        this.order = LondaProductBundle.order(this.rows());
        this.querySelector('[data-bundle-total]').textContent = this.formatter.format(this.order.total / 100);
        const compare = this.querySelector('[data-bundle-compare]');
        compare.hidden = this.order.compare <= this.order.total;
        compare.textContent = this.formatter.format(this.order.compare / 100);
        this.querySelector('[data-bundle-count]').textContent = this.labels.count.replace('{count}',this.order.items.length);
        this.button.disabled = !!this.busy;
      } catch (_) {this.order = null;this.button.disabled = true;this.querySelector('[data-bundle-total]').textContent = '—';this.querySelector('[data-bundle-compare]').hidden = true;}
    }
    status(message,error=false) {
      const node = this.querySelector('[data-bundle-status]');
      node.textContent = message; node.hidden = !message; node.toggleAttribute('data-error',error);
      if (error) node.focus({preventScroll:true});
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy || this.product.busy) return;
      this.update();
      if (!this.order) {this.status(this.labels.unavailable,true);return;}
      if (!this.form.reportValidity() || !this.product.form.reportValidity()) return;
      const items = this.order.items.map(item=>({...item}));
      const properties = {};
      for (const [key,value] of new FormData(this.product.form)) {
        const match = key.match(/^properties\[(.*)\]$/);
        if (match && typeof value === 'string' && value) properties[match[1]] = value;
      }
      if (Object.keys(properties).length) items[0].properties = properties;
      this.busy = true;this.product.setBusy(true);this.form.setAttribute('aria-busy','true');this.button.textContent = this.labels.adding;
      this.status('');this.querySelector('[data-bundle-cart]').hidden = true;this.update();
      let added = false;
      try {
        const response = await fetch(this.product.data.addUrl,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        let result;try {result = await response.json();} catch (_) {result = null;}
        if (!response.ok) {
          this.status((typeof result?.description === 'string' ? result.description : this.labels.error),true);
          this.querySelector('[data-bundle-cart]').hidden = false;return;
        }
        added = true;this.status(this.labels.added.replace('{count}',items.length));
        this.querySelector('[data-bundle-cart]').hidden = false;
        const info = {button:this.button,product:this.product,data:{items},response:result};
        document.dispatchEvent(new CustomEvent('theme:cart::added',{detail:info}));
        this.dispatchEvent(new CustomEvent('londa:cart-added',{bubbles:true,detail:info}));
        this.product.refreshCart().catch(()=>{});
      } catch (_) {
        if (!added) {this.status(this.labels.error,true);this.querySelector('[data-bundle-cart]').hidden = false;}
      } finally {
        this.busy = false;this.product.setBusy(false);this.form.setAttribute('aria-busy','false');this.button.textContent = this.labels.add;this.update();
      }
    }
    disconnectedCallback() {this.controller?.abort();this.ready = false;}
  }
  customElements.define('londa-product-bundle',LondaProductBundle);
})();
